import { BusinessType } from 'store/slices/businessesSlice';

export const getInitialSelectedBusinessState: () => BusinessType = () => {
  return {
    businessId: '',
    name: '',
    logoUrl: '',
    category: '',
    industry: '',
    activeDealCount: 0,
    activeDeals: [],
    wonValue: 0,
    clientFitScore: 0,
    tags: [],
    lists: [],
    website: '',
    country: '',
    employeeCount: 0,
    revenue: 0,
    description: '',
    createdAt: '',
    updatedAt: '',
    successRate: 0,
    ticker: '',
    employees: 0,
    isDeleted: false,
    zoominfoCompanyId: '',
    ceo: '',
    createdBy: '',
    lastEnrichedAt: '',
    createdById: '',
    headquarters: '',
    foundedYear: 0,
    annualRevenue: 0,
    totalDealCount: 0,
    avgVelocity: null,
    ourContacts: 0,
    isFollowing: false,
    isTargeted: false,
  };
};
